import { helperServices } from "../../shared/helper";
import history from "../../shared/utils/history";
import { apiFetch } from "../../shared/helper/apiFetch";

const basePath = "/api";

// -------------------- Logout --------------------
function logout() {
  localStorage.removeItem("user");
  history.push("/");
  window.location.reload();
}

// -------------------- Handle Response --------------------
function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    const token = response.headers.get("Authorization");

    if (token) {
      localStorage.setItem("token", JSON.stringify(token));
    }

    if (!response.ok) {
      if (response.status === 401) logout();
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

// -------------------- Helper: Build Headers --------------------
function buildHeaders() {
  const accessToken = helperServices.getAuthorization() || "";

  
    console.log("✅ Access token received:", accessToken);
    
    if(accessToken == ""){
        console.log("❌ No access token found");
    }
  

  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: accessToken,
  };
}
// -------------------- Doctor APIs --------------------
function getDoctorsByDept() {
  const url = `${basePath}/master/doctor`;
  const requestOptions = { method: "GET", headers: buildHeaders() };
  return apiFetch(url, requestOptions);
}

function getDoctorInfo(data) {
  const url = `${basePath}/master/doctors`;
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  return apiFetch(url, requestOptions);
}

function addDoctor(data) {
  const url = `${basePath}/master/doctor`;
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  return apiFetch(url, requestOptions);
}

function updateDoctor(data) {
  const url = `${basePath}/master/doctor`;
  const requestOptions = {
    method: "PUT",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  return apiFetch(url, requestOptions);
}

// -------------------- Lists --------------------
// function getDoctorList() {
// //  const url = `${basePath}/v1/doctors?type=doctor`;
//   const url = `${basePath}/v1/person`;
//   const requestOptions = { method: "GET", headers: buildHeaders() };
//   return apiFetch(url, requestOptions);
// }
// function getDoctorList() {
//   var accessToken;
//   if (helperServices.getAuthorization()) {
//     accessToken = helperServices.getAuthorization();
//   }
//   const requestOptions = {
//     method: "GET",
//     headers: {
//       Accept: "application/json",
//       "Content-Type": "application/json",
//       Authorization: accessToken,
//     },
//     // body: JSON.stringify(),
//   };
//   const url = basePath + `/v1/person`;
//   return fetch(url, requestOptions)
//     .then(handleResponse)
//     .then((data) => {

//       return data;
//     } );
// }
function getDoctorList() {
  const url = `${basePath}/v1/person`;
  const rawToken = localStorage.getItem("token");
  const authorization = helperServices.getAuthorization();

  console.warn("[AUTH-DIAG] Calling person API", {
    url,
    time: new Date().toISOString(),
    page: window.location.href,
    tokenInLocalStorage: Boolean(rawToken),
    rawTokenLength: rawToken?.length || 0,
    authorizationPresent: Boolean(authorization),
    authorizationLength: authorization?.length || 0,
  });

  const requestOptions = { method: "GET", headers: buildHeaders() };
  return apiFetch(url, requestOptions);
}

// function getDoctorListB() {
//  const url = `${basePath}/v1/doctors?type=doctor`;
//   // const url = `${basePath}/v1/person`;
//   const requestOptions = { method: "GET", headers: buildHeaders() };
//   return apiFetch(url, requestOptions);
// }

function getDepartmentList() {
  const url = `${basePath}/v1/departments`;
  const requestOptions = { method: "GET", headers: buildHeaders() };
  return apiFetch(url, requestOptions);
}

/**
 * Resolve a department id by its name (case-insensitive).
 * Returns the department object's id if found, otherwise null.
 */
// async function getDepartmentIdByName(name) {
//   if (!name) return null;
//   try {
//     const resp = await getDepartmentList();
//     // Response shapes vary: try resp.department, resp.data, or resp
//     const list = resp?.department || resp?.data || resp || [];
//     const arr = Array.isArray(list) ? list : (Array.isArray(list?.department) ? list.department : []);
//     const lower = String(name).trim().toLowerCase();
//     const match = arr.find((d) => {
//       const n = d?.name || d?.department || d?.departmentName || d?.deptName || '';
//       return String(n).trim().toLowerCase() === lower;
//     });
//     return match ? (match.id ?? match.departmentId ?? null) : null;
//   } catch (err) {
//     console.warn('getDepartmentIdByName failed', err);
//     return null;
//   }
// }
async function getDepartmentIdByName(name) {
  if (!name) return null;

  try {
    const resp = await getDepartmentList();

    const department = resp.department.find(
      d => d.name.toLowerCase() === name.toLowerCase()
    );

    return department ? department.id : null;
  } catch (error) {
    console.error(error);
    return null;
  }
}
function getSalaryTypeList() {
  const url = `${basePath}/v1/salarytype`;
  const requestOptions = { method: "GET", headers: buildHeaders() };
  return apiFetch(url, requestOptions);
}

function getFloorList() {
  const url = `${basePath}/v1/allFloors`;
  const requestOptions = { method: "GET", headers: buildHeaders() };
  return apiFetch(url, requestOptions);
}

function getDeskList() {
  const url = `${basePath}/v1/deskLists`;
  const requestOptions = { method: "GET", headers: buildHeaders() };
  return apiFetch(url, requestOptions);
}

function getRoleList() {
  const url = `${basePath}/v1/role`;
  const requestOptions = { method: "GET", headers: buildHeaders() };
  return apiFetch(url, requestOptions);
}

function getStaffList() {
  const url = `${basePath}/v1/staff`;
  const requestOptions = { method: "GET", headers: buildHeaders() };
  return apiFetch(url, requestOptions);
}

function getDoctorListByType(type) {
  const url = `${basePath}/v1/doctors?type=${type}`;

  // const requestOptions = {
  //   method: "POST",
  //   headers: buildHeaders(),
  //   body: JSON.stringify({
  //     type: type
  //   })
  //};
const requestOptions = { method: "GET", headers: buildHeaders() }; return apiFetch(url, requestOptions); }
//   return apiFetch(url, requestOptions);
// }

// -------------------- Zoom --------------------
function generateZoomToken() {
  const url = `${basePath}/v1/zoom`;
  const requestOptions = { method: "GET", headers: buildHeaders() };
  return apiFetch(url, requestOptions);
}

// -------------------- Tags & Procedures --------------------
function addtags(data) {
  const url = `${basePath}/v1/editProcedure`;
  const requestOptions = {
    method: "PUT",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  return apiFetch(url, requestOptions);
}

function addProcedure(data) {
  const url = `${basePath}/v1/procedure`;
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  return apiFetch(url, requestOptions);
}

// -------------------- Notes & Templates --------------------
function reviewNotes(data) {
  const url = `${basePath}/v1/getMeetingNotes?patientId=${data.patientId}&groupId=${data.groupid}&visitId=${data.visitId}`;
  const requestOptions = { method: "GET", headers: buildHeaders() };
  return apiFetch(url, requestOptions);
}

function listTemplates() {
  const url = `${basePath}/v1/ehr/template/active`;
  const requestOptions = { method: "GET", headers: buildHeaders() };
  return apiFetch(url, requestOptions);
}

// -------------------- Assign Doctor --------------------
function getAssignedDoctor(data) {
  const url = `${basePath}/v1/ipd/getdoctor`;
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  return apiFetch(url, requestOptions);
}

function assignDoctor(data) {
  const url = `${basePath}/v1/ipd/person`;
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  return apiFetch(url, requestOptions);
}

function updateMeetingStatus(data) {
  const url = `${basePath}/v1/meetingStatus?visitId=${data.visitId}`;
  const requestOptions = { method: "PUT", headers: buildHeaders() };
  return apiFetch(url, requestOptions);
}

// -------------------- Service & Package --------------------
function getServiceList(data) {
  const url = `${basePath}/v1/packageService?visitId=${data.visitId}&searchTerm=${data.searchTerm}`;
  const requestOptions = { method: "GET", headers: buildHeaders() };
  return apiFetch(url, requestOptions);
}

function getPackageList() {
  const url = `${basePath}/v1/package`;
  const requestOptions = { method: "GET", headers: buildHeaders() };
  return apiFetch(url, requestOptions);
}

function addService(data) {
  const url = `${basePath}/v1/packageService`;
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  return apiFetch(url, requestOptions);
}

function updateService(data) {
  const url = `${basePath}/v1/packageService`;
  const requestOptions = {
    method: "PUT",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  return apiFetch(url, requestOptions);
}

function addPackage(data) {
  const url = `${basePath}/v1/addPackage`;
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  return apiFetch(url, requestOptions);
}

// -------------------- Room Management --------------------
function getRoomList(data) {
  // Add category filtering only for callers that explicitly request it.
  // Existing room-list consumers keep the original URL and behavior.
  const roomCategoriesQuery = Array.isArray(data.roomCategories) && data.roomCategories.length
    ? `&roomCategories=${encodeURIComponent(data.roomCategories.join(","))}`
    : "";
  const url = `${basePath}/v1/rooms?facilityId=${data.facilityId}&roomStatus=${data.roomStatus}${roomCategoriesQuery}`;
  const requestOptions = { method: "GET", headers: buildHeaders() };
  return apiFetch(url, requestOptions);
}

function getAssignedRoom(data) {
  const visitId = data?.visitId ?? data?.visitid ?? data;
  const url = `${basePath}/v1/room/assignedroom?visitId=${visitId}`;
  const requestOptions = { method: "GET", headers: buildHeaders() };
  return apiFetch(url, requestOptions);
}

function getAssignedAllRoomlist(data) {
  const visitId = data?.visitId ?? data?.visitid ?? data;
  const url = `${basePath}/v1/room/assignedallroomlist?visitId=${visitId}`;
  const requestOptions = { method: "GET", headers: buildHeaders() };
  return apiFetch(url, requestOptions);
}

function assignRoom(data) {
  const url = `${basePath}/v1/room/roomBook?visitId=${data.visitid}`;
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  return apiFetch(url, requestOptions);
}

function roomCheckout(data) {
  const url = `${basePath}/v1/room/roomCheckout?visitId=${data.visitid}`;
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  return apiFetch(url, requestOptions);
}

// -------------------- Products --------------------
function getProductIdList() {
  const url = `${basePath}/v1/packageService/productId`;
  const requestOptions = { method: "GET", headers: buildHeaders() };
  return apiFetch(url, requestOptions);
}

function getProductDetails(data, location) {
  const url = `${basePath}/v1/searchProduct?searchvalue=${data}&location=${location}`;
  const requestOptions = { method: "POST", headers: buildHeaders() };
  return apiFetch(url, requestOptions);
}

// -------------------- Doctor CRUD --------------------
function saveDoctor(data) {
  const url = `${basePath}/v1/doctoradd`;
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  return apiFetch(url, requestOptions);
}

function modifyDoctor(data) {
  const url = `${basePath}/v1/doctoredit?id=${data.personId}`;
  const requestOptions = {
    method: "PUT",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  return apiFetch(url, requestOptions);
}

function deletedoctor(data) {
  const url = `${basePath}/v1/doctorremove?id=${data.personId}`;
  const requestOptions = {
    method: "PUT",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  return apiFetch(url, requestOptions);
}

// -------------------- Appointments & Consultant --------------------
function addDoctorAppointments(data) {
  const url = `${basePath}/v1/doctorAppointment`;
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  return apiFetch(url, requestOptions);
}

function addConsultant(data, type, flag) {
  const url = `${basePath}/v1/addConsultant?type=${type}&flag=${flag}`;
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  return apiFetch(url, requestOptions);
}

// -------------------- Case Record & Follow-up --------------------
function addCaseRecord(data) {
  const url = `${basePath}/v1/caserecord`;
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  return apiFetch(url, requestOptions, { showLoader: false });
}

function addFollowupNotes(data) {
  const url = `${basePath}/v1/saveFollowupNotes`;
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  return apiFetch(url, requestOptions);
}

function getFollowupNotes(pid, vid, temp) {
  const url = `${basePath}/v1/getFollowupNotes?patientId=${pid}&visitId=${vid}&templateId=${temp}`;
  const requestOptions = { method: "GET", headers: buildHeaders() };
  return apiFetch(url, requestOptions);
}

// -------------------- Emergency Room --------------------
function getEmergencyRoomList(data) {
  const url = `${basePath}/v1/emergencyroomlist?facilityId=${data.facilityId}&roomStatus=${data.roomStatus}`;
  const requestOptions = { method: "GET", headers: buildHeaders() };
  return apiFetch(url, requestOptions);
}

function getAssignedEmergencyRoom(data) {
  const url = `${basePath}/v1/room/assignedEmergencyRoom?visitId=${data.visitId}`;
  const requestOptions = { method: "GET", headers: buildHeaders() };
  return apiFetch(url, requestOptions);
}

// -------------------- Export --------------------
const doctorServices = {
  logout,
  handleResponse,
  getDoctorsByDept,
  getDoctorInfo,
  addDoctor,
  updateDoctor,
  getDoctorList,
  generateZoomToken,
  addtags,
  addProcedure,
  reviewNotes,
  listTemplates,
  assignDoctor,
  updateMeetingStatus,
  getAssignedDoctor,
  getServiceList,
  addService,
  updateService,
  getRoomList,
  getAssignedRoom,
  getAssignedAllRoomlist,
  assignRoom,
  roomCheckout,
  getProductIdList,
  getDoctorListByType,
  getStaffList,
  saveDoctor,
  modifyDoctor,
  addDoctorAppointments,
  deletedoctor,
  addConsultant,
  getDepartmentList,
  getSalaryTypeList,
  getFloorList,
  getDeskList,
  getRoleList,
  getProductDetails,
  getPackageList,
  addPackage,
  addCaseRecord,
  addFollowupNotes,
  getFollowupNotes,
  getEmergencyRoomList,
  getDepartmentIdByName,
  getAssignedEmergencyRoom,
};

export default doctorServices;
